<div class="host" [class.selected]="selected()">
  @let comp = component();
  <reports-visualization-layout>
    <reports-visualization-title
      slot="header"
      [name]="comp.name"
      [description]="comp.libraryContent"
      size="medium"
    >
      @if (comp.isNew) {
        <rt-badge color="pink-gradient" [text]="'app.common.new' | translate" margin-right-small />
      }
    </reports-visualization-title>

    <rt-icon
      slot="header-actions"
      class="checkmark"
      name="checkmark"
      size="medium"
      margin-left-small-x
    />

    <reports-visualization-renderer
      slot="renderer"
      [rtResizeObserver]="{ initial: true }"
      [resourcesPreviewAvailable]="false"
      [loading]="false"
      [loaded]="true"
      [failed]="false"
      [data]="data()"
      [component]="component()"
      [currColWidth]="currColWidth()"
      [allowRefreshing]="false"
    />
  </reports-visualization-layout>
</div>
